import { __decorate, __extends, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
import { EntityContextService } from './entity-context.service';
var FaqContextService = (function (_super) {
    __extends(FaqContextService, _super);
    function FaqContextService($q) {
        return _super.call(this, $q) || this;
    }
    FaqContextService.$inject = ['$q'];
    FaqContextService = __decorate([
        Injectable('faqContextService'),
        __param(0, Inject('$q')),
        __metadata("design:paramtypes", [Function])
    ], FaqContextService);
    return FaqContextService;
}(EntityContextService));
export { FaqContextService };
